export const fnCallable = {
	submitData: 'chicago_submitData',
	getAllStatusDetails: 'chicago_getAllStatusDetails',
	getDocument: 'chicago_getDocument',
	cancelOrder: 'chicago_cancel',
} as const;

export enum RepresentedByBroker {
	NO = 0,
	YES = 1,
	BUYING_FROM_BUILDER = 2,
}

export interface SubmitResponse {
	PortalUrl: string;
	FileNumber?: number;
	PolicyNumber: string | null;
}

export interface CancelRequest {
	FileNumber: number;
	CancellationCode: number;
	CancellationText: string;
}

export interface CancelResponse {
	ResponseCode: number;
	ResponseMessage: string;
}

export interface AllStatusDetailsRequest {
	FileNumber: number;
	matterId: string;
}

export interface LenderPolicy {
	LenderName: string;
	PolicyNumber: string;
	PolicyDate: string;
	InsuredAmount: number;
	MortgagePriority: number;
	StorageId: number;
}

export interface OwnerPolicy {
	PolicyNumber: string;
	PolicyDate: string;
}

export interface InvoiceItem {
	Quantity: number;
	Amount: number;
	ItemTotal: number;
	TypeOfPolicy: string;
	TypeOfPolicyFr: string;
	Category: string;
	InvoiceType: string;
	PSTVal: number;
	GSTVal: number;
	HSTVal: number;
	QSTVal: number;
}

export interface Invoice {
	InvoiceID: number;
	Paid: boolean;
	InvoiceTotal: number;
	EliteFee: number;
	NetAmountDue: number;
	InvoiceTax: number;
	InvoiceSubTotal: number;
	InvoiceCreateDate: string;
	Status: string;
	RevenueRecognitionDate: string; // datetime,
	InvoiceItems: InvoiceItem[];
}

export interface AllStatusDetailsResponse {
	OrderStatusCode: number;
	OrderStatusMessage: string;
	OrderStatusModified: string; // datetime
	InvoiceModified: string; // datetime,
	DocumentModified: string; // datetime,
	Policies: {
		LenderPolicies: LenderPolicy[];
		OwnerPolicies: OwnerPolicy[];
	};
	Invoices: Invoice[];
	Documents: BaseDocument[];
}

export interface GetDocumentListRequest {
	FileNumber: number;
	LawyerId: string;
}

export interface GetDocumentsRequest {
	FileNumber: number;
	LawyerId: string;
}

export interface GetDocumentRequest {
	StorageId: number;
	LawyerId: string;
}

export interface GetDocumentResponse {
	Document: Document;
}

export interface BaseDocument {
	StorageId: number;
	FileNumber: number;
	FileName: string;
	DateAdded: string;
	DocumentType: string;
	DocumentExtension: string;
	DocumentCategory: string;
}

export interface Error {
	DataHierarchy: string;
	ErrorCode: number;
	ErrorMessage: string;
}

export interface Document extends BaseDocument {
	DocumentRawStream: string;
}

export interface Response<T> {
	ResponseCode: number;
	ResponseDescription: 'Success' | 'Error';
	ResponseObject: ResponseObject<T>;
}

export type ResponseObject<T> = T & {
	ResponseCode: number;
	ResponseMessage: 'Success' | 'Error';
	Error: Error[];
};

export interface APIErrorResponse {
	message: string;
	errors: Error[];
}
